/* eslint-disable no-nested-ternary */
import apiPrd from '../../services/apiPrd'
import { getUrlFromFilters } from '../../utils/filterUtils'

const LoadTableService = {
  async fetchLoadsForTable(operationGroups, status, page = 1, params) {
    const baseUrl = `/shipping/custom/search?status=${status.toUpperCase()}`
    const urlStatus =
      status === 'in_progress'
        ? `&searchStatus=${params[status].searchStatus}`
        : status === 'delivered'
        ? `&searchStatus=${params[status].searchStatus}`
        : status === 'negotiation'
        ? `&launchType=${params[status].launchType}`
        : ''
    const res = await apiPrd.get(
      `${baseUrl}&operationGroups=${operationGroups}&page=${page}&size=20${urlStatus}`
    )
    return res.data
  },

  async fetchLoads(payload) {
    const params = getUrlFromFilters(payload)
    const res = await apiPrd.get(`/shipping/custom/search${params}`)
    return res.data
  },

  async fetchLoadsByParams(
    status,
    operationGroups,
    text,
    page,
    size,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    ...rest
  ) {
    const [
      waitingAtLogisticOperator = false,
      launchType = [],
      trackingStatus = null,
      flProposalSended,
      flShippingNotViewed,
      orderBy,
      flLotAvailable,
    ] = rest
    console.log(flLotAvailable)
    const url = `/shipping/custom/search?status=${status.toUpperCase()}&operationGroups=${operationGroups}&text=${text}&page=${page}&size=${20}`
    const urlLaunchType = launchType.length ? `&launchType=${launchType}` : ''
    const urlStatus = searchStatus.length ? `&searchStatus=${searchStatus}` : ''
    const urlCollectUF = collectUF ? `&collectUF=${collectUF}` : ''
    const urlDeliveryUF = deliveryUF ? `&deliveryUF=${deliveryUF}` : ''
    const urlInitCollectDate = initCollectDate ? `&initCollectDate=${initCollectDate}` : ''
    const urlEndCollectDate = endCollectDate ? `&endCollectDate=${endCollectDate}` : ''
    const urlTrackingStatus = trackingStatus ? `&trackingStatus=${trackingStatus}` : ''
    const urlWaitingAtLogisticOperator = waitingAtLogisticOperator
      ? `&waitingAtLogisticOperator=${waitingAtLogisticOperator}`
      : ''
    const urlFlProposalSended = flProposalSended ? `&flProposalSended=${flProposalSended}` : ''
    const urlFlShippingNotViewed = flShippingNotViewed
      ? `&flShippingNotViewed=${flShippingNotViewed}`
      : ''
    const urlOrderBy = orderBy ? `&orderBy=${orderBy}` : ''
    const urlFlLotAvailable = flLotAvailable ? `&flLotAvailable=${flLotAvailable}` : ''
    const res = await apiPrd.get(
      `${url}${urlStatus}${urlCollectUF}${urlDeliveryUF}${urlInitCollectDate}${urlEndCollectDate}${urlWaitingAtLogisticOperator}${urlLaunchType}${urlTrackingStatus}${urlFlProposalSended}${urlFlShippingNotViewed}${urlOrderBy}${urlFlLotAvailable}`
    )
    return res.data
  },
  async downloadByParams(
    status,
    operationGroups,
    text,
    searchStatus = [],
    launchType = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    waitingAtLogisticOperator = false,
    trackingStatus,
    flProposalSended = false,
    flShippingNotViewed = false,
    orderBy,
    flLotAvailable
  ) {
    const url = `/shipping/active/download?status=${status.toUpperCase()}&operationGroups=${operationGroups}&text=${text}`
    const urlStatus = searchStatus.length ? `&searchStatus=${searchStatus}` : ''
    const urlLaunchType = launchType.length ? `&launchType=${launchType}` : ''
    const urlCollectUF = collectUF ? `&collectUF=${collectUF}` : ''
    const urlDeliveryUF = deliveryUF ? `&deliveryUF=${deliveryUF}` : ''
    const urlInitCollectDate = initCollectDate ? `&initCollectDate=${initCollectDate}` : ''
    const urlEndCollectDate = endCollectDate ? `&endCollectDate=${endCollectDate}` : ''
    const urlWaitingAtLogisticOperator = waitingAtLogisticOperator
      ? `&waitingAtLogisticOperator=${waitingAtLogisticOperator}`
      : ''
    const urlTrackingStatus = trackingStatus ? `&trackingStatus=${trackingStatus}` : ''
    const urlFlProposalSended = flProposalSended ? `&flProposalSended=${flProposalSended}` : ''
    const urlFlShippingNotViewed = flShippingNotViewed
      ? `&flShippingNotViewed=${flShippingNotViewed}`
      : ''
    const urlOrderBy = orderBy ? `&orderBy=${orderBy}` : ''
    const urlFlLotAvailable = flLotAvailable ? `&flLotAvailable=${flLotAvailable}` : ''
    const res = await apiPrd.get(
      `${url}${urlStatus}${urlCollectUF}${urlDeliveryUF}${urlInitCollectDate}${urlEndCollectDate}${urlWaitingAtLogisticOperator}${urlLaunchType}${urlFlProposalSended}${urlTrackingStatus}${urlFlShippingNotViewed}${urlOrderBy}${urlFlLotAvailable}`
    )
    return res.data
  },
  async fetchConfiguredTable(type) {
    const res = await apiPrd.get(`/shippingProperty/set?type=${type}`)
    return res.data
  },
  async fetchUnsetConfiguredTable(type) {
    const res = await apiPrd.get(`/shippingProperty/unset?type=${type}`)
    return res.data
  },
  async setConfiguredTable(newConfigs, type) {
    const res = await apiPrd.post('/shippingProperty/update', { fields: newConfigs, type })
    return res.data
  },
}
export default LoadTableService
